export default "__VITE_ASSET__kZ6EEP6N__"